import moment from "moment";
import constants from "../../../core/constants";

export default function (date) {
  return date ? moment(date).format(constants.dateTimeFormat) : null;
}



// WEBPACK FOOTER //
// ./src/services/auditorHandler/formatters/date.js